var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_129_1208)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.001 1.39885e-06L20 3.99905L8.00051 15.9987L20 27.9984L16.001 31.9975L-1.39887e-06 16.0013L16.001 1.39885e-06Z","fill":"currentColor"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_129_1208"},React.createElement("rect",{"width":"20","height":"32","fill":"white","transform":"translate(20 32) rotate(-180)"})))]);
}

Arrow.defaultProps = {"width":"20","height":"32","viewBox":"0 0 20 32","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
